import { createContext, FC, PropsWithChildren, useState } from "react";
import { IButtonProps } from "@gisce/oficina-virtual-components/dist/components/Button.component";

interface ISubmitButton {
  values: IButtonProps;
  setValues: (values: IButtonProps) => void;
};

export const SubmitButtonContext = createContext<ISubmitButton>({
  values: {}, 
  setValues: () => {}
});

const Contractation: FC<PropsWithChildren> = ({
  children
}) => {
  
  const [submitValues, setSubmitValues] = useState<IButtonProps>({});

  const handleSubmitValues: ISubmitButton["setValues"] = (values) => {
    setSubmitValues(values);
  }
  
  return (
    <SubmitButtonContext.Provider value={{values: submitValues, setValues: handleSubmitValues}}>
      {children}
    </SubmitButtonContext.Provider>
  );
};

export default Contractation;
